import { render, staticRenderFns } from "./SelectedTerm.vue?vue&type=template&id=3406429d&"
import script from "./SelectedTerm.vue?vue&type=script&lang=js&"
export * from "./SelectedTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports